var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJsSquareV3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5H20.5C22.1569 0.5 23.5 1.84315 23.5 3.5V20.5C23.5 22.1569 22.1569 23.5 20.5 23.5H3.5C1.84315 23.5 0.5 22.1569 0.5 20.5V3.5ZM3.5 2.5C2.94772 2.5 2.5 2.94772 2.5 3.5V20.5C2.5 21.0523 2.94772 21.5 3.5 21.5H20.5C21.0523 21.5 21.5 21.0523 21.5 20.5V3.5C21.5 2.94772 21.0523 2.5 20.5 2.5H3.5ZM12.5 10.5C12.5 9.11929 13.6193 8 15 8H18C18.5523 8 19 8.44772 19 9C19 9.55229 18.5523 10 18 10H15C14.7239 10 14.5 10.2239 14.5 10.5C14.5 10.7761 14.7239 11 15 11H16.5C17.8807 11 19 12.1193 19 13.5C19 14.8807 17.8807 16 16.5 16H13.5C12.9477 16 12.5 15.5523 12.5 15C12.5 14.4477 12.9477 14 13.5 14H16.5C16.7761 14 17 13.7761 17 13.5C17 13.2239 16.7761 13 16.5 13H15C13.6193 13 12.5 11.8807 12.5 10.5ZM11.5 9C11.5 8.44772 11.0523 8 10.5 8C9.94772 8 9.5 8.44772 9.5 9V13.5C9.5 13.7761 9.27614 14 9 14H7.5C7.22386 14 7 13.7761 7 13.5C7 12.9477 6.55228 12.5 6 12.5C5.44772 12.5 5 12.9477 5 13.5C5 14.8807 6.11929 16 7.5 16H9C10.3807 16 11.5 14.8807 11.5 13.5V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsSquareV3Icon);
export default __webpack_public_path__ + "static/media/js-square-v3-icon.73eb45c08e62d7a8c92a8c12128d6ff1.svg";
export { ForwardRef as ReactComponent };